// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ab-btn {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.ab-btn .btn {\n  --background: rgba(0, 0, 0, 0.212);\n}\n\n.containerFrame {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
